<template>
  <!-- ── 鏈 / 錢包選單 ── -->
  <div :class="isPC ? 'colu colu-6 flex-colu' : 'colu colu-12'">
    <label class="colu-12 for-label">
      <template v-if="isCrypto">
        {{ $t('Bao.withdrawal_target') }}
      </template>
      <template v-else>
        {{ isPC ? $t('Bao.withdrawal_wallet') : $t('Bao.withdrawal_source') }}
      </template>
    </label>

    <div :class="isPC ? 'withdraw-right-wrap' : 'custom-select-wrap'">
      <div class="lang-select" data-id="withdraw-right-custom">
        <!-- 觸發按鈕 -->
        <button
          :id="isPC ? 'withdraw-right-btn' : undefined"
          :class="isPC ? 'btn-select' : 'cs-btn'"
          @click.prevent="isOpenChain = !isOpenChain"
        >
          <span :class="isPC ? 'wr-text' : ''">
            <template v-if="isCrypto">
              {{ selectedChain ? selectedChain.chain : '' }}
            </template>
            <template v-else>
              {{ getWalletName(selectedWalletKey) }}
            </template>
          </span>
        </button>

        <!-- 下拉選單 -->
        <div v-if="isPC" class="b" :class="{ active: isOpenChain }">
          <ul id="withdraw-right-list" class="wr-list">
            <template v-if="isCrypto">
              <li
                v-for="(chainObj, index) in chainList"
                :key="index"
                @click="onSelectChain(chainObj)"
              >
                {{ chainObj.chain }}
              </li>
            </template>
            <template v-else>
              <li
                v-for="wallet in nonCryptoWallets"
                :key="wallet.key"
                @click="onSelectNonCrypto(wallet)"
              >
                {{ getWalletName(wallet.key) }}
              </li>
            </template>
          </ul>
        </div>

        <!-- Mobile 用 ul.cs-list -->
        <ul v-else class="cs-list" :class="{ active: isOpenChain }">
          <template v-if="isCrypto">
            <li
              v-for="(chainObj, index) in chainList"
              :key="index"
              @click="onSelectChain(chainObj)"
            >
              {{ chainObj.chain }}
            </li>
          </template>
          <template v-else>
            <li
              v-for="wallet in nonCryptoWallets"
              :key="wallet.key"
              :data-value="wallet.key"
              @click="onSelectNonCrypto(wallet)"
            >
              {{ getWalletName(wallet.key) }}
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getWalletImagePath, detectMob } from '@/utils/tool'

export default {
  name: 'WalletSelector',
  props: {
    /** 是否為加密幣模式 */
    isCrypto: {
      type: Boolean,
      default: false
    },
    selectedWallet: {
      type: Object,
      default: null
    },
    selectedWalletKey: {
      type: String,
      default: null
    },
    selectedChain: {
      type: Object,
      default: null
    },
    chainList: {
      type: Array,
      default: () => []
    },
    /** 只包含 main / commission */
    nonCryptoWallets: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpenCurrency: false,
      isOpenChain: false
    }
  },
  computed: {
    isPC() {
      return !detectMob()
    }
  },
  methods: {
    getWalletImagePath,
    getWalletName(key) {
      const map = {
        main: this.$t('Bao.main_wallet'),
        commission: this.$t('Bao.commission_wallet')
      }
      return map[key] || key
    },
    onSelectNonCrypto(wallet) {
      this.isOpenCurrency = false
      this.isOpenChain = false
      this.$emit('select-non-crypto', wallet)
    },
    onSelectChain(chainObj) {
      this.isOpenChain = false
      this.$emit('select-chain', chainObj)
    }
  }
}
</script>
